import React from 'react';
import PropTypes from 'prop-types';

const ShouldRenderDiv = ({ shouldRender, className, children }) => {
  if (!shouldRender) {
    return null;
  }
  return (
    <div className={className}>
      {children}
    </div>
  );
};
ShouldRenderDiv.propTypes = {
  shouldRender: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.any,
};

export default ShouldRenderDiv;



// WEBPACK FOOTER //
// ./src/components/Atoms/ShouldRenderDiv/index.js